import { createSlice } from '@reduxjs/toolkit';

const hydrationSlice = createSlice({
    name: 'hasHydrated',
    initialState: false,
    reducers: {
        setHydrated: () => true,
    },
});

export const hydrationReducer = hydrationSlice;

export const { setHydrated } = hydrationSlice.actions;
